[
  {
    "name": "$city",
    "displayName": "City",
    "description": "The city of the event sender, parsed from IP.",
    "type": "string",
    "exampleValue": "San Francisco, Los Angeles"
  },
  {
    "name": "$country_code",
    "displayName": "Country Code",
    "description": "The two-letter country code of the event sender, parsed from IP.",
    "type": "string",
    "exampleValue": "US, ES (Spain)"
  },
  {
    "name": "$region",
    "displayName": "Region",
    "description": "The region (state or province) of the event sender that is parsed from IP.",
    "type": "string",
    "exampleValue": "California, New York"
  },
  {
    "name": "$timezone",
    "displayName": "Timezone",
    "description": "The timezone of the event sender, parsed from IP.",
    "type": "string",
    "exampleValue": "PST (UTC-08:00)"
  }
]
